import axios from 'axios'

import StoreMixin from '@/store/mixin'

export default {
  mixins: [StoreMixin],

  methods: {
    getBaseUrl () {
      if (window.location.hostname.includes('localhost') || window.location.hostname.includes('::1')) {
        return 'http://localhost:3001/v1'
      } else if (window.location.hostname === 'web') {
        return 'http://gateway-payment-api-portal-1:3001/v1'
      } else if (window.location.hostname.includes('-test.')) {
        return 'https://portal-api-test.paynetworx.com/v1'
      } else if (window.location.hostname.includes('-qa.')) {
        return 'https://portal-api-qa.paynetworx.com/v1'
      } else if (process.env.NODE_ENV === 'production') {
        return 'https://portal-api.paynetworx.com/v1'
      } else {
        return 'https://portal-api-dev.paynetworx.com/v1'
      }
    },

    async api (opts) {
      let headers = {}

      try {
        let result = await axios({
          url: `${this.getBaseUrl()}${opts.url}`,
          method: opts.method || 'get',
          data: opts.data || {},
          params: opts.params || {},
          headers: headers,
          withCredentials: true
        })

        return result
      } catch (err) {
        console.log('API Error:')
        console.log(err)
        if (err.response && err.response.status === 401) {
          // this.forceLogout()
          // this.$router.go(-1)
        }
        throw err
      }
    },

    forceOTPVerify () {
      this.$router.push('/otp_verify')
    },

    async forceLogout () {
      console.log('forceLogout')

      try {
        await this.api({
          url: `/users/token_invalidate`,
          method: 'get'
        })
      } catch (err) {
        throw new Error(err)
      } finally {
        this.$store.commit('clearErrors', 'timed-out-error-message, login-error')
        this.$store.commit('clearSuccesses')
        this.$store.commit('clearInfo')
        this.$store.commit('clearPersistentMessages')
        this.$cookie.delete('token')
        this.$store.commit('logout')
        this.$router.push('/')
      }
    },

    async getS3SecuredUrl () {
      try {
        const response = await this.api({
          url: `/accounts/${this.merchant.id}/upload?type=${this.file.type}`,
          method: 'get'
        })
        return response
      } catch (err) {
        throw new Error('Error getting presigned url: ', err)
      }
    },

    async uploadImageToS3Bucket (url, file) {
      await fetch(url, {
        method: 'put',
        body: file,
        headers: {
          'Content-Type': `${this.file.type}`
        }
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`)
          }
        })
        .catch(error => {
          throw new Error('Error uploading file:', error)
        })
    },

    async addImageToDataBase (url) {
      const imageUrl = url.split('?')[0]
      const urlParts = imageUrl.split('/')
      const fileName = urlParts[urlParts.length - 1]

      try {
        await this.api({
          url: `/accounts/${this.merchant.id}/save`,
          method: 'put',
          data: {
            image: fileName
          },
          headers: {
            'Content-Type': `application/json`
          }
        })
      } catch (err) {
        throw new Error('Error adding logo to server: ', err)
      }
      window.location.reload(true)
    },

    async removeImageFromDatabase () {
      try {
        await this.api({
          url: `/accounts/${this.merchant.id}/logo`,
          method: 'delete'
        })
      } catch (err) {
        throw new Error('Error removing logo from server: ', err)
      }
      window.location.reload(true)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/api.js